import { Form, Modal, notification, UploadFile } from "antd";
import React, { useState } from "react";
import AttachFilesPage from "../OrderContextMenu/CoverWizardModal/components/FormPages/AttachFilesPage";
import OrderDto from "../../../store/actions/dtos/OrderDto";
import { RcFile } from "antd/lib/upload/interface";
import { uploadAttachments } from "../../../store/actions/orderFlowActionCreators";

export type EditAttachmentsForm = {
  soNo: string;
  comments: string;
  fileList: UploadFile[];
};

export function EditOrderAttachmentsModal({
  modalPayloadState: [modalPayload, setModalPayload],
  onSubmit,
}: {
  modalPayloadState: [OrderDto | null, (order: OrderDto | null) => void];
  onSubmit: () => void;
}) {
  const [formIsSubmitting, setFormIsSubmitting] = useState(false);
  const [form] = Form.useForm();
  return (
    <Modal
      title={""}
      open={!!modalPayload}
      footer={null}
      centered
      maskClosable={false}
      closable={!formIsSubmitting}
      width={560}
      style={{ maxHeight: "97vh" }}
      keyboard={false}
      onCancel={() => {
        setModalPayload(null);
        form.resetFields();
      }}
    >
      <Form
        form={form}
        preserve
        layout="vertical"
        colon={false}
        name="poolCoverQuoteForm"
        initialValues={{ fileList: [], comments: "" }}
        onFinish={async (values: EditAttachmentsForm) => {
          setFormIsSubmitting(true);
          const files = values.fileList
            .filter((file) => !!file?.originFileObj)
            .map((file) => {
              return file.originFileObj as RcFile;
            });

          const [uploadAttachmentsRes, uploadAttachmentsError] =
            await uploadAttachments(
              files,
              !!modalPayload?.soNo ? modalPayload.soNo : "",
              values.comments
            );

          if (!!uploadAttachmentsError) {
            setFormIsSubmitting(false);
            notification.error({
              message: "Error uploading attachments",
              description:
                "There was an error uploading your attachments, please try again later.",
            });
            return;
          }
          setFormIsSubmitting(false);
          form.resetFields();
          setModalPayload(null);
          onSubmit();
        }}
      >
        <AttachFilesPage
          hideBackButton
          submitOnNext
          formIsSubmitting={formIsSubmitting}
          wizardPageNumberState={[0, () => {}]}
          summary={`SO#: ${modalPayload?.soNo}`}
          title="Edit Attachments"
        />
      </Form>
    </Modal>
  );
}
